import AOS from 'aos';
import 'aos/dist/aos.css';

export const aosInit = () => {
    AOS.init({
        once: true, // 👈 Animation runs only once
    });
};